import { render, staticRenderFns } from "./SelectCurrency.vue?vue&type=template&id=215b38d4&scoped=true&"
import script from "./SelectCurrency.vue?vue&type=script&lang=js&"
export * from "./SelectCurrency.vue?vue&type=script&lang=js&"
import style0 from "./SelectCurrency.vue?vue&type=style&index=0&id=215b38d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b38d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
